// This file contains tooltip content for all the nodes in vision workflow, which was previously embedded
// directly in the node component. By moving it here, we improve readability and maintainability of
// the node component code. Any future updates to the tooltip content can be made here without needing
// to modify the node component itself.

import React from "react";

export interface NodeTooltipContent {
  text: React.ReactNode;
}

export const NODE_TOOLTIPS: Record<string, NodeTooltipContent> = {
  videoInput: {
    text: (
      <>
        Entry point for <strong>video data</strong> into the pipeline. Supports RTSP, WebRTC, file URLs, and local video
        sources.
      </>
    )
  },
  detector: {
    text: (
      <>
        Performs <strong>object detection</strong> using ML models like YOLO and RT-DETR. Identifies and localizes
        objects in video frames.
      </>
    )
  },
  tracker: {
    text: (
      <>
        Maintains <strong>object identity</strong> across frames using algorithms like ByteTrack and StrongSORT.
        Essential for tracking movement.
      </>
    )
  },
  segmentation: {
    text: (
      <>
        Provides <strong>pixel-level segmentation</strong> using models like SAM 2. Creates precise object masks for
        detailed analysis.
      </>
    )
  },
  analyticsProcessor: {
    text: (
      <>
        Detects <strong>zone-based events</strong> like object entry/exit and dwell time. Processes tracked objects into
        actionable analytics events.
      </>
    )
  },
  metricsCalculator: {
    text: (
      <>
        Aggregates analytics events into <strong>time-windowed metrics</strong> (hourly, daily, weekly). Calculates
        counts, sums, and averages.
      </>
    )
  },
  dashboardOutput: {
    text: (
      <>
        Real-time <strong>visualization dashboard</strong> with live updates via WebSocket. Displays metrics and events
        as they occur.
      </>
    )
  },
  reportGenerator: {
    text: (
      <>
        Generates <strong>scheduled reports</strong> in PDF, Excel, or CSV format. Includes historical data and
        customizable templates.
      </>
    )
  },
  databaseService: {
    text: (
      <>
        Provides <strong>persistent storage</strong> for events and metrics. Supports PostgreSQL and MongoDB with
        configurable retention.
      </>
    )
  },
  apiGateway: {
    text: (
      <>
        Exposes <strong>REST/WebSocket endpoints</strong> for external integrations. Supports multiple authentication
        methods.
      </>
    )
  }
};
